export type NewsletterWidgetAttribute =
  | 'submit-url'
  | 'recaptcha-site-key'
  | 'recaptcha-action'
  | 'source'
  | 'page-url'
  | 'data-preview-scenario';

export type NewsletterPreviewScenario = 'empty' | 'partial' | 'complete';

export type NewsletterWidgetProps = {
  pageUrl: string;
  previewScenario: NewsletterPreviewScenario;
  recaptchaAction: string;
  recaptchaSiteKey: string | undefined;
  source: string | undefined;
  submitUrl: string | undefined;
};

export type NewsletterEventName =
  | 'adipa-newsletter-ready'
  | 'adipa-newsletter-submit'
  | 'adipa-newsletter-success'
  | 'adipa-newsletter-error';

export const OBSERVED_NEWSLETTER_WIDGET_ATTRIBUTES: NewsletterWidgetAttribute[] = [
  'submit-url',
  'recaptcha-site-key',
  'recaptcha-action',
  'source',
  'page-url',
  'data-preview-scenario',
];

const DEFAULT_RECAPTCHA_ACTION = 'newsletter';

export function readNewsletterWidgetProps(element: HTMLElement): NewsletterWidgetProps {
  const raw = element.getAttribute('data-preview-scenario');
  const previewScenario: NewsletterPreviewScenario =
    raw === 'partial' || raw === 'complete' ? raw : 'empty';
  return {
    pageUrl: element.getAttribute('page-url') ?? window.location.href,
    previewScenario,
    recaptchaAction: element.getAttribute('recaptcha-action') ?? DEFAULT_RECAPTCHA_ACTION,
    recaptchaSiteKey: element.getAttribute('recaptcha-site-key') ?? undefined,
    source: element.getAttribute('source') ?? undefined,
    submitUrl: element.getAttribute('submit-url') ?? undefined,
  };
}
